import React from 'react'
import RightBarGroup from './RightBarGroup'
import Input from './Input'
import { Button } from '@bm-js/atlascloud-ui'
import {
  ChangeEvent,
  DynamicContentType,
  jsonCopy,
  QuicklinksData,
} from '@bm-js/atlascloud-shared'
import MarginOptions from './MarginOptions'
import Select from './Select'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<QuicklinksData>
  setData: (e: ChangeEvent<QuicklinksData['links'] | string>) => void
}

const QuickLinksEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  const onChange = (
    e: ChangeEvent,
    i: number,
    key: keyof QuicklinksData['links'][0]
  ) => {
    const updated = jsonCopy(content.data)
    updated.links[i][key] = e.target.value
    const updateEvent = {
      target: {
        name: 'links',
        value: updated.links,
      },
    }
    setData(updateEvent)
  }

  const removeLink = (i: number) => {
    const temp = jsonCopy(content.data)
    temp.links.splice(i, 1)
    const e = {
      target: {
        name: 'links',
        value: temp.links,
      },
    }
    setData(e)
  }

  const addLink = () => {
    const temp = jsonCopy(content.data)
    temp.links.push({
      header: tr(TrKey.quickLinksEditorMyLink),
      linkTo: '/',
    })
    const e = {
      target: {
        name: 'links',
        value: temp.links,
      },
    }
    setData(e)
  }

  return (
    <>
      {content.data.links.map((_, i) => (
        <React.Fragment key={`quicklink_edit_${content.uuid}_${i}`}>
          <RightBarGroup title={`${tr(TrKey.quickLinksEditorLink)} #${i + 1}`}>
            <Input
              light
              label={tr(TrKey.quickLinksEditorTextLabel)}
              desc={tr(TrKey.quickLinksEditorTextDescription)}
              id={`linkHeader_${i}`}
              value={content.data.links[i].header}
              onChange={(e) => onChange(e, i, 'header')}
            />
            <Input
              light
              label={tr(TrKey.quickLinksEditorLinkLabel)}
              desc={tr(TrKey.quickLinksEditorLinkDescription)}
              id={`linkHeader_${i}`}
              placeholder={tr(TrKey.quickLinksEditorLinkPlaceholder)}
              value={content.data.links[i].linkTo}
              onChange={(e) => onChange(e, i, 'linkTo')}
            />
            <Button
              danger
              sm
              disabled={content.data.links.length <= 1}
              onClick={() => removeLink(i)}
            >
              {tr(TrKey.quickLinksEditorLinkRemove)}
            </Button>
          </RightBarGroup>
        </React.Fragment>
      ))}
      <div className='flex justify-end mb-6'>
        <Button sm onClick={addLink}>
          {tr(TrKey.quickLinksEditorLinkAdd)}
        </Button>
      </div>
      <MarginOptions setData={setData} content={content} topLine />
      <Select
        light
        label={tr(TrKey.quickLinksEditorColorLabel)}
        name='backgroundColor'
        id='backgroundColor'
        value={content.data.backgroundColor}
        onChange={setData}
      >
        <option value='white'>
          {tr(TrKey.quickLinksEditorColorOptionWhite)}
        </option>
        <option value='primary'>
          {tr(TrKey.quickLinksEditorColorOptionPrimary)}
        </option>
        <option value='accent'>
          {tr(TrKey.quickLinksEditorColorOptionAccent)}
        </option>
      </Select>
    </>
  )
}

export default QuickLinksEditor
